<!--
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-04-28 11:32:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-27 17:06:04
-->
<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, ref, withDefaults } from 'vue';
import { Button as AButton, Alert } from 'ant-design-vue';
import { CloudUploadOutlined } from '@ant-design/icons-vue';
import type { Api, IUpload } from '../types';
import { Modal } from '../../modal';
import UploadDragger from './UploadDragger.vue';

interface IUploadModal extends IUpload {
  hiddenList?: boolean; // 隐藏列表

  api?: Api;

  params?: PropType<object>;

  multiple?: boolean;

  maxSize?: number;

  maxCount?: number; // 最大上传数量

  uploadNow?: boolean;

  accept?: string;

  readOnly?: boolean;
  bordered?: boolean;
  readOnlyStyle?: object;
  readOnlyClassName?: string | null;
}

const props = withDefaults(defineProps<IUploadModal>(), {
  accept: '*',
  multiple: true,
  maxCount: Infinity,
  uploadNow: false,
  hiddenList: false,
  readOnly: undefined,
});

const uploadDraggerRef = ref();

const visible = ref<boolean>(false);

const getHelpText = computed(() => {
  const helpTexts: string[] = [];

  if (props.accept !== '*') {
    helpTexts.push(`支持${props.accept}格式`);
  }

  if (props.maxSize) {
    helpTexts.push(`单个文件不超过${props.maxSize}MB`);
  }

  if (props.maxCount && props.maxCount !== Infinity) {
    helpTexts.push(`最多只能上传${props.maxCount}个文件`);
  }
  return helpTexts.join('，');
});

const handleOk = () => {
  uploadDraggerRef.value.startUpload();

  visible.value = false;
};
</script>

<template>
  <a-button type="primary" @click="visible = true">
    <CloudUploadOutlined />
    上传</a-button
  >
  <Modal v-model:visible="visible" title="上传" ok-text="开始上传" width="800px" @ok="handleOk">
    <div style="text-align: center">
      <Alert :message="getHelpText" type="info" banner />
      <UploadDragger
        v-bind="$attrs"
        ref="uploadDraggerRef"
        :api="api"
        :params="params"
        :multiple="multiple"
        :accept="accept"
        :max-count="maxCount"
        :max-size="maxSize"
        :upload-now="uploadNow"
        :hidden-list="hiddenList"
      >
      </UploadDragger>
    </div>
  </Modal>
</template>

<style></style>
